import React, {Component} from 'react';
import '../App.scss';

export default class BusOffer extends Component {
  render() {
    return (
      <div>
        <div className="offers-container">
          <div className="polaroid">
            <a
              href="https://www.confirmtkt.com/booking/offers/paypal-offer.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="300px"
                height="150px"
                alt="Offers"
                src="https://www.confirmtkt.com/img/promotion/busoffers/festival.png?v=1.0.2"
              />
            </a>
            <div>
              Use Code : <b>FESTIVAL</b>
            </div>
          </div>

          {/* <div className="polaroid">
            <a
              href="https://www.confirmtkt.com/booking/offers/paypal-offer.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="300px"
                height="150px"
                alt="Offers"
                src="https://www.confirmtkt.com/img/promotion/banner_lg.png"
              />
            </a>
            <div>
              Use Code : <b>SUMMER</b>
            </div>
          </div>

          <div className="polaroid">
            <a
              href="https://www.confirmtkt.com/booking/offers/paypal-offer.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                width="300px"
                height="150px"
                alt="Offers"
                src="https://www.confirmtkt.com/img/promotion/PaywithPaypal_banner1_ct.png"
              />
            </a>
            <div>
              Use Code : <b>SUMMER</b>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}
